<template>
  <div class="my-projects">
    <Navbar />
    <div class="mt-5 pt-5 kovatek-width">
      <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4 mt-4">
        <div class="text-left mt-3 ml-5 mb-4">
          <a-icon class="mr-1" type="arrow-left" />
          <span class="go-back" @click="goBack">Go Back</span>
        </div>
        <h4 class="font-weight-bolder kova-text text-left mt-4 mt-md-5">My Projects</h4>
      </div>
      <div v-if="loading" class="page-loader">
        <hollow-dots-spinner
          :animation-duration="1000"
          :dot-size="15"
          :dots-num="3"
          color="#20409a"
        />
      </div>
      <div v-else class="container-fluid">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-8 mt-lg-3">
            <div class="bg-light p-2 mt-3 border add-rounded text-center scrollbar jobs-post">
              <div class="d-flex justify-content-around flex-wrap">
                <div class="new-project p-4 shadow-sm border bg-white my-3">
                  <div class="d-flex justify-content-center">
                    <div class="mt-4 pt-2">
                      <router-link to="/hire">
                        <a-icon
                          class="add-new"
                          style="font-size: 80px"
                          type="plus-circle"
                          theme="filled"
                        />
                        <p class="font-weight-bolder mt-2 text-dark">Post a New Job</p>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class @click="jobPage(item.ID)" v-for="(item, i) in projects" :key="item+i">
                  <JobPost
                    :title="item.Title"
                    :status="item.Status"
                    :id="item.ID"
                    :text="item.Description"
                    class="pointer"
                  />
                </div>
                <!-- <div class="" @click="jobPage">
                                <JobPost title="CO" :status="2" :id="23498" text="Completed Html Catalogue" class="pointer"  />
                            </div>
                            <div class="" @click="jobPage">
                                <JobPost title="CO" :status="4" :id="23498" text="Completed Html Catalogue" class="pointer"  />
                            </div>
                            <div class="" @click="jobPage">
                                <JobPost title="CO" :status="2" :id="23498" text="Completed Html Catalogue" class="pointer"  />
                            </div>
                            <div class="" @click="jobPage">
                                <JobPost title="CO" :status="4" :id="23498" text="Completed Html Catalogue" class="pointer"  />
                </div>-->
              </div>
            </div>
            <div class="mt-5 container">
              <h5 class="font-weight-bolder kova-text text-left mt-5 py-3">Completed Project</h5>
            </div>
            <div class="bg-light p-4 border add-rounded text-center mb-5 container">
              <!-- <div :key="work" v-for="work in workHistory">
                            <div class="row">
                                <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                    <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                </div>
                                <div class="col-9 col-sm-9 col-md-7 text-left">
                                    <h4 class="font-weight-bolder kova-text">{{work.title}}</h4>
                                    <p class="font-italic text-size2">{{work.comment}}</p>
                                    <p class="text-left font-weight-bolder ctrl-size mb-1"><font-awesome-icon class="ctrl-size" icon="clock" /> 30 minutes ago for</p>
                                    <p class="text-left font-weight-bolder ctrl-size my-0"><span class="bid-color mr-2"><font-awesome-icon class="ctrl-size mr-2" icon="gavel" />2 bids</span><font-awesome-icon class="ctrl-size" icon="tag" /> PHP, Website Design, Wordpress, CSS, HTML</p>
                                </div>
                            
                                <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 float-text">
                                        <h5 class="font-weight-bolder kova-text">$169</h5>
                                        <div class="pt-0 mt-1 mt-md-5 pt-md-5">
                                            <font-awesome-icon class="icon-size mr-3" style="color:#FE9816" icon="bookmark" />
                                        </div>
                                </div>
                            </div>
                            <hr>
              </div>-->
              <div v-if="hasCompletedProject">
                <div v-for="(item,i) in completedProjects" :key="i">
                  <div class="row">
                    <div class="class col-3 col-sm-3 col-md-2 pl-1">
                      <img
                        src="../assets/kovatek/Mask Group 46.svg"
                        alt
                        class="rounded-circle img-height"
                      />
                    </div>
                    <div class="col-9 col-sm-9 col-md-7 text-left">
                      <h4 class="font-weight-bolder kova-text">{{item.Title}}</h4>
                      <p class="font-italic text-size2" v-html="item.Description"></p>
                      <p class="text-left font-weight-bolder ctrl-size mb-1">
                        <font-awesome-icon class="ctrl-size" icon="clock" />
                        {{showTime(item.CreatedAt)}} ago
                      </p>
                      <p class="text-left font-weight-bolder ctrl-size my-0">
                        <span class="bid-color mr-2">
                          <font-awesome-icon class="ctrl-size mr-2" icon="gavel" />
                          {{item.TotalBids}} bids
                        </span>
                        <font-awesome-icon class="ctrl-size" icon="tag" />
                        <span v-for="skill in item.Skills" :key="skill" class="px-1">{{skill}},</span>
                      </p>
                    </div>

                    <div
                      class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 float-text"
                    >
                      <h5 class="font-weight-bolder kova-text">${{item.StartBudget}}</h5>
                      <!-- <div class="pt-0 mt-1 mt-md-5 pt-md-5">
                                                <font-awesome-icon class="icon-size mr-3" style="color:#FE9816" icon="bookmark" />
                      </div>-->
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
              <div v-else>
                <h4>No Completed Project(s)</h4>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-4 px-3 pl-lg-0 pr-lg-3">
            <div class></div>
            <div class style="position:sticky;top:80px;">
              <Notifications />
              <Messages />
            </div>
          </div>
        </div>
      </div>
      <div class="modal">
        <!-- <a-button type="primary" @click="showModal">
                Open Modal with customized footer
        </a-button>-->
        <a-modal v-model="visible" title onOk="handleOk" width="750px">
          <template slot="footer">
            <a-button key="back" @click="handleCancel">Cancel</a-button>
            <a-button
              key="submit"
              style="background-color:#20409a; color: #fff"
              :loading="loading"
              @click="showCallScheduled"
            >schedule</a-button>
          </template>
          <div class="mt-4 p-4 bg-light"></div>
        </a-modal>
      </div>
      <div>
        <a-modal v-model="callScheduled" title onOk="handleOk" width="600px">
          <template slot="footer">
            <a-button
              key="submit"
              style="background-color:#20409a; color: #fff"
              @click="callScheduledOk"
            >Ok</a-button>
          </template>
          <div class="mt-4 p-4 bg-light"></div>
        </a-modal>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import JobPost from "@/components/JobPost.vue";
import Notifications from "@/components/Notifications.vue";
import Messages from "@/components/Messages.vue";
import calcTime from "@/helpers/moment";
import { HollowDotsSpinner } from "epic-spinners";

export default {
  name: "my-projects",
  components: {
    Navbar,
    Footer,
    JobPost,
    Messages,
    Notifications,
    HollowDotsSpinner
  },
  data() {
    return {
      workHistory: [
        {
          title: "Customise Wordpress login",
          duration: " Mar 2016 - Sep 2018",
          star: 5,
          status: "You are hired",
          comment:
            "Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable",
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48
        },
        {
          title: "Wordpress login",
          star: 5,
          status: "Undergoing Interview",
          comment:
            "Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable",
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19
        }
      ],
      skills: [
        "Laravel Framework",
        "Nodejs",
        "Golang",
        "jQuery",
        "JavaScript",
        "database",
        "Modeling",
        "Vue.js",
        "Express.js",
        "Ext JS",
        "Docker"
      ],
      loading: true,
      visible: false,
      callScheduled: false,
      otherDetails: false,
      projects: [],
      hasCompletedProject: false,
      completedProjects: [],
      error: ""
    };
  },
  methods: {
    styleScroll: function() {
      let isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
      let isSafari =
        /Safari/.test(navigator.userAgent) &&
        /Apple Computer/.test(navigator.vendor);
      let scrollbarDiv = document.querySelector(".scrollbar");
      if (!isChrome && !isSafari) {
        scrollbarDiv.innerHTML = "You need Webkit browser to run this code";
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    jobPage(projectId) {
      this.$router.push(`hiring?projectId=${projectId}`);
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      // this.loading = true;
      // setTimeout(() => {
      this.visible = false;
      // this.loading = false;
      // }, 3000);
    },
    handleCancel() {
      this.visible = false;
    },
    showCallScheduled() {
      // this.loading = true;
      //     setTimeout(() => {
      this.visible = false;
      // this.loading = false;
      this.callScheduled = true;
      // }, 3000);
    },
    callScheduledOk() {
      this.callScheduled = false;
    },
    showOtherDetails() {
      this.otherDetails = !this.otherDetails;
    },
    showTime(date) {
      return calcTime(date);
    }
  },
  computed: {},
  mounted() {
    this.$store
      .dispatch("projects/getProjects", { offset: 0, limit: 20 })
      .then(resp => {
        this.projects = resp.data;
        this.projects.map(item => {
          if (item.Status === 6) {
            this.completedProjects.push(item);
            this.hasCompletedProject = true;
          }
        });

        this.loading = false;
      })
      .catch(err => {
        this.error = err.message;
        this.loading = false;
      });
  }
};
</script>
<style scoped>
.browse-list {
  width: 80%;
}
.sort-by {
  position: relative;
  top: 33px;
}
.icon-size {
  font-size: 25px;
}
.icon-size1 {
  font-size: 20px;
}
.img-height {
  width: 80px;
  height: 80px;
}
.icon-env {
  font-size: 20px;
}
.ctrl-size {
  font-size: 10px;
}
.ctrl-size-1 {
  font-size: 20px;
}
.ctrl-size-2 {
  font-size: 11px;
}
.latest {
  color: #2db7f5;
}
.jobs-post {
  height: 400px;
  overflow-y: scroll;
}
.new-project {
  width: 260px;
}
.add-new {
  color: #20409a;
}
.add-new:hover {
  color: #0c2b80;
}
.bg-skills {
  background-color: #4bb38e;
  color: #fff;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
  .new-project {
    width: 300px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .img-height {
    width: 60px;
    height: 60px;
  }
  .new-project {
    width: 260px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
  .float-text {
    display: flex;
    justify-content: space-between;
    padding-right: 50px;
  }
  .float-text h6 {
    float: left;
  }
}

@media screen and (max-width: 550px) {
  .ctrl-search {
    width: 55%;
  }
  .img-height {
    width: 65px;
    height: 65px;
  }
}
</style>